import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "hidden", "list", "option"]
  static values = { options: Array }

  connect() {
    this._onOutsideClick = this.closeList.bind(this)
    document.addEventListener("click", this._onOutsideClick)
    this.selectedIndex = -1
  }

  disconnect() {
    document.removeEventListener("click", this._onOutsideClick)
  }

  filter() {
    const query = this.inputTarget.value.toLowerCase().trim()
    this.hiddenTarget.value = this.inputTarget.value.trim()
    this.selectedIndex = -1

    let visibleCount = 0
    this.optionTargets.forEach((opt) => {
      const text = opt.dataset.value.toLowerCase()
      const match = text.includes(query)
      opt.classList.toggle("hidden", !match)
      if (match) visibleCount++
    })

    if (visibleCount > 0 && query.length > 0) {
      this.openList()
    } else {
      this.closeList()
    }
  }

  showAll() {
    this.optionTargets.forEach((opt) => opt.classList.remove("hidden"))
    this.selectedIndex = -1
    this.openList()
  }

  select(event) {
    const value = event.currentTarget.dataset.value
    this.inputTarget.value = value
    this.hiddenTarget.value = value.toLowerCase()
    this.closeList()
  }

  navigate(event) {
    if (!this.isOpen()) return

    const visible = this.optionTargets.filter((o) => !o.classList.contains("hidden"))
    if (visible.length === 0) return

    if (event.key === "ArrowDown") {
      event.preventDefault()
      this.selectedIndex = Math.min(this.selectedIndex + 1, visible.length - 1)
      this.highlightOption(visible)
    } else if (event.key === "ArrowUp") {
      event.preventDefault()
      this.selectedIndex = Math.max(this.selectedIndex - 1, 0)
      this.highlightOption(visible)
    } else if (event.key === "Enter" && this.selectedIndex >= 0) {
      event.preventDefault()
      visible[this.selectedIndex].click()
    } else if (event.key === "Escape") {
      this.closeList()
    }
  }

  highlightOption(visible) {
    visible.forEach((opt, i) => {
      opt.classList.toggle("bg-teal-50", i === this.selectedIndex)
      opt.classList.toggle("text-teal-700", i === this.selectedIndex)
    })
  }

  openList() {
    this.listTarget.classList.remove("hidden")
  }

  closeList(event) {
    if (event && this.element.contains(event.target)) return
    this.listTarget.classList.add("hidden")
    this.selectedIndex = -1
  }

  isOpen() {
    return !this.listTarget.classList.contains("hidden")
  }
}
